/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ion-item[_ngcontent-%COMP%]   [slot=start][_ngcontent-%COMP%]{margin-right:16px}ion-item[_ngcontent-%COMP%]   [slot=end][_ngcontent-%COMP%]{margin-left:16px}ion-item[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}"];
export { styles as styles };
